import { permissoes, routesNames } from '@/core/constants'
import Sobre from '@/views/pages/sobre/Sobre.vue'
import Manual from '@/views/pages/sobre/manual/Manual.vue'

export default [
	{
		name: routesNames.SOBRE.SOBRE_VIEW,
		path: '/sobre',
		component: Sobre,
		meta: {
			menu: {
				title: 'Sobre',
				icon: 'mdi-lightbulb',
			},
			authorities: [permissoes.ataMenu],
		},
		children: [
			{
				name: routesNames.SOBRE.MANUAL_VIEW,
				path: '/manual',
				component: Manual,
				meta: {
					menu: {
						title: 'Manual',
					},
					page: {
						title: 'Sobre Ata Registro de Preço',
						subtitle: 'Manualize',
					},
				},
			},
		],
	},
]
